const SuccessPage = ({ applicationId, company, paymentResponse }) => {
  return (
    <>
      {paymentResponse.status !== "success" ? (
        <>
          <div className="text-xl text-[#4D4D4D] font-sans font-bold my-7 px-5">
            Payment Failed!
          </div>
          <div className="text-xl text-[#4D4D4D] font-sans font-bold my-7 px-5">
            Your payment has failed, someone from our support team will reach out to you
          </div>
        </>
      ) : (
        <>
          <div className="text-xl text-[#4D4D4D] font-sans font-bold my-7 px-5">
            Payment Success!
          </div>
          <div className="text-xl text-[#4D4D4D] font-sans font-bold my-7 px-5">
            Your application has been successfully registered with us
          </div>
          <div className="my-5 px-5">
            <div className="text-base text-[#4D4D4D] font-sans">
              Your Application Number
            </div>
            <div className="text-base font-sans text-[#404040] font-medium">
              {applicationId || ""}
            </div>
          </div>
        </>
      )}

    </>
  );
};

export default SuccessPage;
